import { render, staticRenderFns } from "./JobDescriptionModal.vue?vue&type=template&id=68ce2114&scoped=true&"
import script from "./JobDescriptionModal.vue?vue&type=script&lang=js&"
export * from "./JobDescriptionModal.vue?vue&type=script&lang=js&"
import style0 from "./JobDescriptionModal.vue?vue&type=style&index=0&id=68ce2114&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68ce2114",
  null
  
)

export default component.exports